import React, { useEffect } from 'react';
import i18n from 'i18next';
import { toast } from 'react-toastify';
import { useModal } from 'react-modal-hook';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import useStyles from './HeaderActions.styles';
import { Button } from '../../../../common/components/buttons';
import TextButton from '../../../../common/components/buttons/TextButton';
import useAgent from '../../../../common/hooks/useAgent';
import clientAgent from '../../../agents/clientAgent';
import Tooltip from '../../../../common/components/Tooltip';
import ConfirmationModal from '../../../../common/components/modals/ConfirmationModal';
import Can from '../../../../common/contexts/abilityContext';

const HeaderActions = ({ onBackClick }) => {
  const classes = useStyles();

  const { values, isSubmitting, dirty } = useFormikContext();
  const [deleteClient, deletedClient] = useAgent(clientAgent.deleteClient);

  useEffect(() => {
    if (deletedClient) {
      toast.success(i18n.t('common.message.success.deleted', { entity: 'client' }));
      onBackClick();
    }
  }, [deletedClient, onBackClick]);

  const [showModal, hideModal] = useModal(
    () => (
      <ConfirmationModal
        id="deletionModal"
        closeModal={hideModal}
        onCancelClick={hideModal}
        onConfirmClick={() => deleteClient(values.id)}
        confirmButtonLabel={i18n.t('common.button.confirm')}>
        {i18n.t('client.message.deletionConfirmation')}
      </ConfirmationModal>
    ),
    []
  );

  const handleDeleteButtonClick = () => showModal();

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Can do="create" on="client">
          {values.id && <TextButton onClick={handleDeleteButtonClick}>{i18n.t('client.button.deleteClient')}</TextButton>}

          <Button id="backButton" onClick={onBackClick}>
            {i18n.t('mission.button.backToList')}
          </Button>
        </Can>

        <Tooltip title={i18n.t('common.userInterface.noModificationsToSave')} placement="top" hidden={dirty}>
          <Button id="saveButton" primary type="submit" disabled={isSubmitting || !dirty}>
            {values.id ? i18n.t('common.button.save') : i18n.t('common.button.create')}
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

HeaderActions.propTypes = {
  onBackClick: PropTypes.func,
};

HeaderActions.defaultProps = {
  onBackClick: undefined,
};

export default HeaderActions;
